import {
  assertSAPIProduct, assertSAPIProducts,
} from '@/types/SearchAPI/SAPIProduct'

import { ClientSideCache } from '@/services/CacheService'
import { SEARCH_API } from '@/services/Configuration'
import { log } from '@/services/Log'

import type { SAPIProductsType } from '@/types/SearchAPI/SAPIProduct'
import type { Product as ProductType } from '@/types'
import allPromisesWithRetries from '@/helpers/allPromisesWithRetries'

const CacheBySku = ClientSideCache(({ sku }: { sku: string }) => sku)
const CacheBySkus = ClientSideCache((skus: string[]) => skus.sort().join(','))

type SearchAPISkusFetcher = (skus: string[]) => Promise<ProductType[]>
const getProductBySkus: SearchAPISkusFetcher = CacheBySkus(async (skus) => {
  const [{ default: Axios }] = await allPromisesWithRetries(() => [import('axios')])
  const products = (await Axios.get<SAPIProductsType>(`${SEARCH_API}/product`, { params: { skus: skus.join(',') } })).data || []
  if (products) {
    try {
      assertSAPIProducts(products)
    } catch (e) {
      log(e)
    }
  }
  // TODO: Implement internal type and asserion transformer
  // this is ugly but its here as a temporary type assertion implementation scope limitation
  return products as unknown as ProductType[]
})

type SearchAPISkuFetcher = (input: { sku: string }) => Promise<ProductType>
const getProductBySku: SearchAPISkuFetcher = CacheBySku(async ({ sku }) => {
  log(`Product.bySku sku: ${sku}`, { sku })
  const product = (await getProductBySkus([sku]))?.[0]
  if (product) {
    try {
      assertSAPIProduct(product)
    } catch (e) {
      log(e)
    }
  }

  // TODO: Implement internal type and asserion transformer
  // this is ugly but its here as a temporary type assertion implementation scope limitation
  return product as unknown as ProductType
})

export const Product = {
  bySkus: getProductBySkus,
  bySku: getProductBySku,
}

export default Product
